module.exports = __webpack_public_path__ + "static/media/arguments-in-evidence.18c267c5.jpg";